import React from 'react';
import {FormattedMessage} from 'react-intl';

type Props = {
  loading?: boolean;
  size?: number;
  marginTop?: number;
  text?: string;
};
export const LightLoadingSpinner: React.FC<Props> = (props) => {
  const {loading = true, size = 125, marginTop = 75, text} = props;
  if (!loading) return <></>;
  return (
    <div data-name='light-loading-spinner' style={{width: '100%', height: 'auto'}}>
      <div style={{marginTop, height: size, overflow: 'hidden', display: 'flex', justifyContent: 'center'}}>
        <div
          className={'fas fa-circle-notch fa-spin'}
          style={{
            fontSize: size,
            color: 'var(--dlLoadingSpinnerTextColor)',
          }}
        />
      </div>
      {text && (
        <div
          style={{
            fontSize: 'var(--dlFontSizeLarger)',
            color: 'var(--dlComponentBoxFont)',
          }}
        >
          <FormattedMessage id={text} defaultMessage={'Searching...'} description={'label for loading spinner'} />
        </div>
      )}
    </div>
  );
};
